import { Component, Prop, h } from '@stencil/core';

import { bannerSizeType } from '../../../utils/utils.interactive-banner';
@Component({
  tag: 'banner-heading',
  styleUrl: 'banner-heading.css',
  shadow: true,
})
export class BannerHeading {
  @Prop() hiddenOnMobile: boolean = false;
  @Prop() showDesktop: boolean = false;
  @Prop() headingSize: bannerSizeType = 'medium';

  render() {
    const classNames = {
      'text-base/4': this.headingSize === 'xsmall',
      'text-xl/5': this.headingSize === 'small',
      'text-2xl': this.headingSize === 'medium' && !this.showDesktop,
      'flex antialiased tracking-tight font-extrabold text-clrs-white text-2xl leading-8 mb-2 whitespace-nowrap text-left': !this.showDesktop,
      'w-64 whitespace-normal text-4xl py-2 mt-px font-extrabold text-left': this.showDesktop,
      hidden: this.hiddenOnMobile && !this.showDesktop,
    };
    return <h1 class={classNames}>We Want to Buy Your Car!</h1>;
  }
}
